import routes from './routes.router.js';
import { createRouter, createWebHistory } from 'vue-router';
import middlewaresInitializer from './middlewaresInitializer.router';

export const previousRoute = ref(null);

const router = createRouter({
	routes,
	history: createWebHistory('/app/'),
	scrollBehavior: () => {
		return { top: 0, behavior: 'smooth' };
	},
});

router.beforeEach((to, from, next) => {
	previousRoute.value = from;
	next();
});

router.afterEach((to) => {
	const robots = document.querySelector<HTMLMetaElement>('meta[name="robots"]') ?? document.createElement('meta');
	robots.setAttribute('name', 'robots');

	if (to.meta?.noindex) {
		robots.setAttribute('content', 'noindex,nofollow');
		document.head.appendChild(robots);
		return;
	}

	if (robots.parentElement) robots.parentElement.removeChild(robots);
});

middlewaresInitializer(router);

export default router;
